<template>
  <div
    id="section-8"
    class="relative bg-complementer-4 smx:bg-complementer-6 z-50"
  >
    <div
      style="border-radius: 80px 0px 0px 0px"
      class="bg-complementer-5 pt-16 lg:pt-24 px-8 lg:ml-8"
    >
      <div
        class="bg-complementer-5 relative lg:max-w-screen-xl self-auto items-center justify-center mx-auto"
      >
        <div
          style="border-radius: 80px 0px 0px 0px"
          class="flex flex-col bg-complementer-5"
        >
          <div class="flex smx:flex-col lg:justify-between w-full lg:pb-10">
            <div class="flex-col justify-center">
              <div class="w-56 h-auto">
                <img
                  width="224"
                  height="42"
                  alt="Logo Monocrom OCA Omni Communication Assistant"
                  src="../../assets/image/logo_white.webp"
                  class="lg:w-full smx:w-auto"
                />
              </div>
              <p class="text-sm text-white mt-6">
                Jl. Medan Merdeka Sel. No.11, RW.2, Gambir,
                <br class="hide-br" />
                Kecamatan Gambir, Kota Jakarta Pusat, <br class="hide-br" />
                Daerah Khusus Ibukota Jakarta 10110
              </p>
            </div>
            <div class="flex flex-wrap justify-center">
              <div class="w-full flex justify-end desktop-view">
                <div class="flex flex-col pr-4 lg:pr-8">
                  <div
                    class="text-md hover:text-white text-white font-semibold mb-4"
                  >
                    {{ section_1?.product?.name }}
                  </div>
                  <a
                    :href="`${hostPath}/blast`"
                    class="cursor-pointer text-md hover:text-white text-white my-1"
                    >OCA Blast</a
                  >
                  <a
                    :href="`${hostPath}/interaction`"
                    class="cursor-pointer text-md hover:text-white text-white my-1"
                    >OCA Interaction</a
                  >
                  <!-- <a @click="goto('profiling');" class="cursor-pointer text-md hover:text-white text-white my-1">OCA Profiling</a> -->
                  <!-- <a
                    :href="`${hostPath}/whatsapp-api`"
                    class="cursor-pointer text-md hover:text-white text-white my-1"
                    >OCA WhatsApp Business API</a
                  > -->
                  <a
                    :href="`${hostPath}/bot-builder`"
                    class="cursor-pointer text-md hover:text-white text-white my-1"
                    >OCA AI</a
                  >
                </div>
                <div class="flex flex-col pr-4 lg:pr-8" style="max-width: 164px;">
                  <div
                    class="text-md hover:text-white text-white font-semibold mb-4"
                  >
                    {{ section_1?.solution?.name }}
                  </div>
                  <a
                    :href="`${hostPath}/ukm`"
                    class="text-md hover:text-white cursor-pointer text-white my-1"
                    >UMKM</a
                  >
                  <!-- <a
                    :href="`${hostPath}/solutions/startup`"
                    class="text-md hover:text-white cursor-pointer text-white my-1"
                    >Startup</a
                  > -->
                  <a
                    :href="`${hostPath}/solutions/enterprise`"
                    class="text-md hover:text-white cursor-pointer text-white my-1"
                    >Enterprise</a
                  >
                  <a
                    :href="`${hostPath}/whatsapp-api`"
                    class="cursor-pointer text-md hover:text-white text-white my-1"
                    >OCA WhatsApp Business API</a
                  >
                </div>
                <div class="flex flex-col pr-4 lg:pr-12">
                  <a
                    :href="`${hostOrigin}/harga`"
                    class="cursor-pointer text-md hover:text-white text-white font-semibold mb-4"
                  >
                    {{ section_1?.pricing?.name }}
                  </a>
                </div>
                  <div class="flex flex-col pr-4 lg:pr-12">
                  <a
                    :href="`${hostOrigin}/partnership`"
                    class="cursor-pointer text-md hover:text-white text-white font-semibold mb-4"
                  >
                    {{ section_1?.partnership?.name }}
                  </a>
                </div>
                <div class="flex flex-col pr-4 lg:pr-8" style="max-width: 154px">
                  <div
                    class="text-md hover:text-white cursor-pointer text-white font-semibold mb-4"
                  >
                    {{ section_1?.resources?.name }}
                  </div>
                  <!-- <a
                    href="https://ocaindonesia.co.id/resources"
                    class="text-md hover:text-white cursor-pointer text-white my-1"
                    >FAQ</a
                  > -->
                  <a
                    href="https://docs.ocaindonesia.co.id/product-documentation"
                    target="_blank"
                    class="text-md hover:text-white cursor-pointer text-white my-1"
                    >OCA Product Documentation</a
                  >
                  <a
                    href="https://ocaindonesia.co.id/blog/"
                    class="text-md hover:text-white cursor-pointer text-white my-1"
                    >Blog</a
                  >
                </div>
                <div class="flex flex-col pr-4 lg:pr-0">
                  <a
                    :href="`${hostOrigin}/about-us`"
                    class="inline-block cursor-pointer text-md hover:text-white text-white font-semibold mb-4"
                  >
                    {{ section_1?.about?.name }}
                  </a>
                </div>
              </div>
              <div class="w-full flex flex-col my-4 mobile-view">
                <div class="flex flex-1 flex-row">
                  <div class="flex flex-1 flex-col my-4">
                    <div
                      class="text-md hover:text-white text-white font-semibold mb-4"
                    >
                      {{ section_1?.product?.name }}
                    </div>
                    <a
                      href="blast"
                      class="text-md hover:text-white cursor-pointer text-white my-1"
                      >OCA Blast</a
                    >
                    <a
                      href="interaction"
                      class="text-md hover:text-white cursor-pointer text-white my-1"
                      >OCA Interaction</a
                    >
                    <!-- <a
                      href="whatsapp-api"
                      class="text-md hover:text-white cursor-pointer text-white my-1"
                      >OCA WhatsApp Business API</a
                    > -->
                    <a
                      href="bot-builder"
                      class="text-md hover:text-white cursor-pointer text-white my-1"
                      >OCA AI</a
                    >

                    <!-- <a @click="goto('profiling');" class="text-md hover:text-white cursor-pointer text-white my-1">OCA Profiling</a> -->
                  </div>
                  <div class="flex flex-1 flex-col my-4">
                    <div
                      class="text-md hover:text-white text-white font-semibold mb-4"
                    >
                      {{ section_1?.resources?.name }}
                    </div>
                    <!-- <a
                      href="https://ocaindonesia.co.id/resources"
                      class="text-md hover:text-white text-white cursor-pointer my-1"
                      >FAQ</a
                    > -->
                     <a
                      href="https://docs.ocaindonesia.co.id/product-documentation"
                      target="_blank"
                      class="text-md hover:text-white text-white cursor-pointer my-1"
                      >OCA Documentation</a
                    >
                    <a
                      href="https://ocaindonesia.co.id/blog/"
                      class="text-md hover:text-white text-white cursor-pointer my-1"
                      >Blog</a
                    >
                  </div>
                </div>

                <div class="flex flex-1 flex-row">
                  <div class="flex flex-1 flex-col my-4">
                    <a
                      :href="`${hostOrigin}/harga`"
                      class="text-md hover:text-white text-white font-semibold cursor-pointer mb-4"
                    >
                      {{ section_1?.pricing?.name }}
                    </a>
                  </div>
                  <div class="flex flex-1 flex-col my-4">
                    <a
                      :href="`${hostOrigin}/partnership`"
                      class="text-md hover:text-white text-white font-semibold cursor-pointer mb-4"
                    >
                      {{ section_1?.partnership?.name }}
                    </a>
                  </div>
                </div>

                <div class="flex flex-1 flex-row">
                  <div class="flex flex-1 flex-col my-4">
                    <div
                      class="text-md hover:text-white text-white font-semibold mb-4"
                    >
                      {{ section_1?.solution?.name }}
                    </div>
                    <a
                      href="ukm"
                      class="text-md hover:text-white text-white my-1 cursor-pointer"
                      >UMKM</a
                    >
                    <!-- <a
                      href="solutions/startup"
                      class="text-md hover:text-white text-white my-1 cursor-pointer"
                      >Startup</a
                    > -->
                    <a
                      href="solutions/enterprise"
                      class="text-md hover:text-white text-white my-1 cursor-pointer"
                      >Enterprise</a
                    >
                    <a
                      href="whatsapp-api"
                      class="text-md hover:text-white cursor-pointer text-white my-1"
                      >OCA WhatsApp Business API</a
                    >
                  </div>
                  <!-- <div class="flex flex-col my-4">
                    <div
                      class="text-md hover:text-white text-white font-semibold mb-4"
                    >
                      {{ section_1?.pricing?.name }}
                    </div>
                    <a
                      href="pricing"
                      class="text-md cursor-pointer hover:text-white text-white my-1"
                      >{{ section_1?.pricing?.text }}</a
                    >
                  </div> -->
                  <div class="flex flex-1 flex-col my-4">
                    <a
                      :href="`${hostOrigin}/about-us`"
                      class="text-md hover:text-white text-white font-semibold cursor-pointer mb-4"
                    >
                      {{ section_1?.about?.name }}
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Desktop Social Media -->
          <div
            class="w-full border-t border-b border-neutral-40 my-4 desktop-view"
          >
            <div class="flex justify-between py-4">
              <div class="flex flex-row">
                <a
                  class="self-center mx-2"
                  aria-label="LinkedIn"
                  target="_blank"
                  href="https://www.linkedin.com/company/ocaindonesia/mycompany/"
                >
                  <svg class="self-center mx-2" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_537_269)">
                    <path d="M22.8225 20.9222C23.03 20.9242 23.2 20.7577 23.2021 20.5501C23.2022 20.5417 23.202 20.5332 23.2015 20.5247C23.2015 20.2428 23.0314 20.1082 22.6825 20.1082H22.1187V21.584H22.3307V20.9407H22.5913L22.5973 20.9485L23.0016 21.584H23.2284L22.7934 20.9263L22.8225 20.9222ZM22.5773 20.7744H22.3314V20.2755H22.643C22.804 20.2755 22.9875 20.3017 22.9875 20.5125C22.9875 20.755 22.8018 20.7744 22.576 20.7744H22.5773Z" fill="white"/>
                    <path d="M17.2911 19.0726H14.2842V14.3637C14.2842 13.2408 14.2642 11.7954 12.7203 11.7954C11.1542 11.7954 10.9147 13.0188 10.9147 14.282V19.0723H7.90781V9.38893H10.7944V10.7123H10.8348C11.4234 9.7059 12.5178 9.10482 13.6829 9.14804C16.7305 9.14804 17.2924 11.1526 17.2924 13.7604L17.2911 19.0726ZM4.515 8.06528C3.5513 8.06546 2.76994 7.28434 2.76975 6.32068C2.76956 5.35698 3.55069 4.57562 4.51434 4.57543C5.47805 4.57524 6.25941 5.35637 6.25959 6.32003C6.25978 7.28373 5.4787 8.06514 4.515 8.06528ZM6.01842 19.0727H3.00844V9.38893H6.01842V19.0727ZM18.7901 1.78314H1.49747C0.680203 1.7739 0.00998437 2.42856 0 3.24582V20.6102C0.00965625 21.4279 0.679781 22.0832 1.49747 22.0745H18.7901C19.6095 22.0847 20.2822 21.4295 20.2935 20.6102V3.2446C20.2819 2.4257 19.609 1.77109 18.7901 1.78187V1.78314Z" fill="white"/>
                    <path d="M22.6029 19.4507C21.8387 19.458 21.2251 20.0835 21.2325 20.8477C21.2398 21.6119 21.8653 22.2254 22.6295 22.2181C23.3938 22.2108 24.0073 21.5853 24 20.8211C23.9927 20.0673 23.3834 19.4579 22.6295 19.4507H22.6029V19.4507ZM22.6346 22.0591C21.9645 22.0703 21.3807 21.5368 21.3695 20.8667C21.3583 20.1967 21.8925 19.6445 22.5625 19.6333C23.2326 19.6222 23.7848 20.1563 23.7959 20.8263V20.8467C23.81 21.5021 23.29 22.0449 22.6346 22.0591Z" fill="white"/>
                    </g>
                    <defs>
                    <clipPath id="clip0_537_269">
                    <rect width="24" height="24" fill="white"/>
                    </clipPath>
                    </defs>
                  </svg>
                </a>

                <a
                  class="self-center mx-2"
                  aria-label="Facebook"
                  target="_blank"
                  href="https://www.facebook.com/OCA.IDN/"
                >
                  <svg class="self-center mx-2" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M12 0.999878C14.0488 1.02326 15.8997 1.52679 17.5526 2.51046C19.1859 3.4745 20.5445 4.84143 21.4986 6.48053C22.4763 8.14345 22.9768 10.0055 23.0001 12.0668C22.942 14.8871 22.0525 17.2959 20.3314 19.2932C18.6104 21.2905 16.4062 22.5262 14.1244 22.9999V15.0927H16.2816L16.7695 11.9853H13.5029V9.95008C13.4848 9.52816 13.6182 9.11367 13.8791 8.78157C14.1403 8.44856 14.6003 8.27353 15.2592 8.25648H17.2317V5.53451C17.2034 5.52541 16.9349 5.4894 16.426 5.42649C15.849 5.35897 15.2687 5.3229 14.6877 5.31846C13.3728 5.32452 12.3328 5.69544 11.5679 6.43122C10.8029 7.16678 10.4121 8.23099 10.3956 9.62384V11.9853H7.9097V15.0927H10.3956V22.9999C7.59386 22.5262 5.38963 21.2905 3.6686 19.2932C1.94757 17.2959 1.05807 14.8871 1 12.0668C1.02323 10.0054 1.52372 8.14336 2.50146 6.48053C3.45554 4.84144 4.81417 3.47451 6.44743 2.51046C8.10034 1.52698 9.9512 1.02345 12 0.999878Z" fill="white"/>
                  </svg>
                </a>

                <a
                  class="self-center mx-2"
                  aria-label="Instagram"
                  target="_blank"
                  href="https://www.instagram.com/oca.indonesia/?hl=id"
                >
                  <svg class="self-center mx-2" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M7.44428 1.07705C6.27388 1.13227 5.47461 1.31905 4.77589 1.59362C4.05275 1.87544 3.43983 2.25362 2.82998 2.86566C2.22014 3.4777 1.8446 4.09106 1.56476 4.81531C1.29394 5.51557 1.11046 6.31549 1.05876 7.48656C1.00706 8.65762 0.995618 9.03404 1.00134 12.0212C1.00706 15.0084 1.02026 15.3828 1.07702 16.5563C1.1329 17.7265 1.31902 18.5255 1.59358 19.2245C1.87584 19.9476 2.25358 20.5603 2.86584 21.1704C3.47811 21.7804 4.09103 22.1551 4.81703 22.4354C5.51663 22.7058 6.31678 22.8901 7.48762 22.9414C8.65847 22.9927 9.03533 23.0045 12.0216 22.9988C15.0079 22.9931 15.3839 22.9799 16.5572 22.9242C17.7304 22.8686 18.5253 22.6811 19.2244 22.4079C19.9476 22.125 20.5607 21.7479 21.1703 21.1354C21.78 20.5229 22.1553 19.9091 22.4349 19.1844C22.706 18.4848 22.8901 17.6847 22.9409 16.5147C22.9922 15.3406 23.0043 14.9657 22.9986 11.979C22.9928 8.99224 22.9794 8.6178 22.9238 7.44476C22.8681 6.27171 22.6818 5.47509 22.4074 4.77571C22.1247 4.05256 21.7474 3.4403 21.1354 2.8298C20.5233 2.2193 19.9091 1.8442 19.1846 1.56524C18.4846 1.29441 17.6849 1.10983 16.514 1.05923C15.3432 1.00863 14.9663 0.995653 11.9789 1.00137C8.99155 1.00709 8.61755 1.01985 7.44428 1.07705ZM7.57276 20.9625C6.50026 20.9158 5.91791 20.7376 5.52983 20.5885C5.01591 20.3905 4.64983 20.1511 4.26307 19.7681C3.87631 19.3851 3.63871 19.0177 3.43807 18.5049C3.28737 18.1168 3.10587 17.5351 3.05571 16.4626C3.00114 15.3034 2.9897 14.9554 2.98332 12.0186C2.97694 9.08178 2.98816 8.73418 3.03899 7.57456C3.08475 6.50293 3.26405 5.91993 3.41299 5.53207C3.61099 5.01749 3.84947 4.65207 4.23337 4.26552C4.61727 3.87898 4.98357 3.64094 5.49683 3.4403C5.88448 3.28894 6.46616 3.10898 7.53822 3.05794C8.69829 3.00294 9.04589 2.99194 11.9822 2.98556C14.9186 2.97918 15.2671 2.99018 16.4276 3.04122C17.4992 3.08786 18.0824 3.2654 18.4698 3.41522C18.984 3.61322 19.3498 3.85104 19.7364 4.23561C20.1229 4.62017 20.3612 4.98515 20.5618 5.49951C20.7134 5.88605 20.8934 6.46751 20.944 7.54024C20.9992 8.7003 21.0117 9.04812 21.017 11.9843C21.0223 14.9204 21.0119 15.2691 20.9611 16.4283C20.9143 17.5008 20.7365 18.0833 20.5871 18.4719C20.3891 18.9856 20.1504 19.3519 19.7663 19.7382C19.3822 20.1245 19.0163 20.3625 18.5028 20.5632C18.1156 20.7143 17.5333 20.8947 16.4621 20.9458C15.302 21.0003 14.9544 21.0118 12.017 21.0181C9.07955 21.0245 8.73305 21.0126 7.57298 20.9625M16.5402 6.12101C16.5406 6.3821 16.6185 6.6372 16.7639 6.85404C16.9094 7.07088 17.1158 7.23972 17.3572 7.33922C17.5986 7.43871 17.8641 7.46438 18.1201 7.41299C18.376 7.36159 18.611 7.23544 18.7953 7.05048C18.9796 6.86552 19.1049 6.63007 19.1553 6.3739C19.2058 6.11773 19.1791 5.85235 19.0788 5.61133C18.9784 5.3703 18.8088 5.16446 18.5914 5.01983C18.374 4.8752 18.1187 4.79829 17.8576 4.79881C17.5076 4.79951 17.1722 4.93919 16.9251 5.18714C16.6781 5.43509 16.5396 5.771 16.5402 6.12101ZM6.35198 12.0111C6.35814 15.1307 8.89167 17.6539 12.0106 17.648C15.1296 17.642 17.6545 15.1087 17.6486 11.9891C17.6426 8.86948 15.1084 6.34563 11.9891 6.35179C8.86967 6.35795 6.34604 8.89192 6.35198 12.0111ZM8.3333 12.0071C8.33187 11.2819 8.54552 10.5726 8.94723 9.96878C9.34895 9.36499 9.92068 8.89388 10.5901 8.61502C11.2596 8.33617 11.9967 8.2621 12.7083 8.40217C13.4198 8.54225 14.0739 8.89018 14.5877 9.40196C15.1015 9.91375 15.452 10.5664 15.5949 11.2774C15.7378 11.9884 15.6667 12.7258 15.3905 13.3964C15.1143 14.0669 14.6454 14.6405 14.0432 15.0446C13.441 15.4487 12.7325 15.6652 12.0073 15.6666C11.5258 15.6676 11.0488 15.5738 10.6035 15.3904C10.1582 15.207 9.75345 14.9377 9.41227 14.5979C9.0711 14.2581 8.80021 13.8544 8.61508 13.4099C8.42995 12.9653 8.3342 12.4887 8.3333 12.0071Z" fill="white"/>
                  </svg>
                </a>

                <a
                  class="self-center mx-2"
                  aria-label="Medium"
                  target="_blank"
                  href="https://oca-telekomunikasi.medium.com/"
                >
                <svg class="self-center mx-2" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M13.5373 12C13.5373 15.7639 10.5069 18.8152 6.76866 18.8152C3.03042 18.8152 0 15.7639 0 12C0 8.23617 3.03042 5.18494 6.76866 5.18494C10.5068 5.18494 13.5373 8.23617 13.5373 12Z" fill="white"/>
                  <path d="M20.9627 12.0001C20.9627 15.5431 19.4475 18.4153 17.5784 18.4153C15.7093 18.4153 14.1941 15.5431 14.1941 12.0001C14.1941 8.45701 15.7093 5.58484 17.5784 5.58484C19.4476 5.58484 20.9627 8.45701 20.9627 12.0001Z" fill="white"/>
                  <path d="M23.9999 12.0001C23.9999 15.1745 23.467 17.7479 22.8096 17.7479C22.1522 17.7479 21.6194 15.1745 21.6194 12.0001C21.6194 8.82566 22.1522 6.25232 22.8096 6.25232C23.467 6.25232 23.9999 8.82566 23.9999 12.0001Z" fill="white"/>
                </svg>
                </a>

                <a
                  class="self-center mx-2"
                  aria-label="Twitter"
                  target="_blank"
                  href="https://twitter.com/Ask_OCA?s=20"
                >
                <svg class="self-center mx-2" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M13.6468 10.4686L20.9321 2H19.2057L12.8799 9.3532L7.82741 2H2L9.6403 13.1193L2 22H3.72649L10.4068 14.2348L15.7425 22H21.5699L13.6464 10.4686H13.6468ZM11.2821 13.2173L10.508 12.1101L4.34857 3.29967H7.00037L11.9711 10.4099L12.7452 11.5172L19.2066 20.7594H16.5548L11.2821 13.2177V13.2173Z" fill="white"/>
                </svg>
                </a>

                <a
                  class="self-center mx-2"
                  aria-label="Youtube"
                  target="_blank"
                  href="https://www.youtube.com/channel/UCLNMdDMoe9RTdJw1_yjesfA"
                >
                  <svg
                    class="self-center mx-2"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M20.6338 7.98131C20.5314 7.60124 20.3312 7.25462 20.0532 6.97597C19.7751 6.69731 19.429 6.49633 19.0491 6.39303C17.6407 6.0063 12.0062 6.00001 12.0062 6.00001C12.0062 6.00001 6.37262 5.99371 4.96331 6.36335C4.58371 6.4714 4.23826 6.67523 3.96013 6.95525C3.682 7.23528 3.48052 7.5821 3.37504 7.96242C3.0036 9.37082 3 12.292 3 12.292C3 12.292 2.9964 15.2275 3.36514 16.6215C3.572 17.3922 4.17907 18.0011 4.95072 18.2089C6.37352 18.5956 11.9927 18.6019 11.9927 18.6019C11.9927 18.6019 17.6273 18.6082 19.0357 18.2394C19.4156 18.1363 19.7621 17.9358 20.0408 17.6577C20.3195 17.3796 20.5209 17.0336 20.6248 16.6539C20.9972 15.2464 20.9999 12.3261 20.9999 12.3261C20.9999 12.3261 21.0179 9.38971 20.6338 7.98131ZM10.2039 14.9981L10.2084 9.60196L14.8914 12.3045L10.2039 14.9981Z"
                      fill="white"
                    />
                  </svg>
                </a>

                <a
                  class="self-center mx-2"
                  aria-label="Tiktok"
                  target="_blank"
                  href="https://www.tiktok.com/@oca.indonesia"
                >
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M12.2131 3.015C13.1956 3 14.1705 3.0075 15.1455 3C15.2055 4.14749 15.618 5.31747 16.458 6.12746C17.298 6.95995 18.483 7.34245 19.638 7.46994V10.4924C18.558 10.4549 17.4705 10.2299 16.488 9.76492C16.0605 9.56992 15.663 9.32242 15.273 9.06742C15.2655 11.2574 15.2805 13.4474 15.258 15.6298C15.198 16.6798 14.853 17.7223 14.2455 18.5848C13.2631 20.0248 11.5606 20.9623 9.8131 20.9923C8.74062 21.0523 7.66813 20.7598 6.75314 20.2198C5.23816 19.3273 4.17317 17.6923 4.01568 15.9373C4.00068 15.5623 3.99318 15.1873 4.00818 14.8199C4.14317 13.3949 4.84817 12.0299 5.94315 11.0999C7.18814 10.0199 8.92811 9.50242 10.5556 9.80991C10.5706 10.9199 10.5256 12.0299 10.5256 13.1399C9.7831 12.8999 8.91312 12.9674 8.26062 13.4174C7.78813 13.7249 7.42813 14.1974 7.24064 14.7299C7.08314 15.1123 7.12814 15.5323 7.13564 15.9373C7.31563 17.1673 8.50062 18.2023 9.7606 18.0898C10.6006 18.0823 11.4031 17.5948 11.8381 16.8823C11.9806 16.6348 12.1381 16.3798 12.1456 16.0873C12.2206 14.7449 12.1906 13.4099 12.1981 12.0674C12.2056 9.04492 12.1906 6.02996 12.2131 3.015Z"
                      fill="white"
                    />
                  </svg>
                </a>
              </div>
            </div>
          </div>

          <!-- Mobile Social Media -->
          <div
            class="w-full border-t border-b border-neutral-40 mobile-view my-4"
          >
            <div class="flex flex-col">
              <div class="flex flex-row my-4">
                <a
                  class="self-center lg:mx-2 smx:mr-2"
                  target="_blank"
                  href="https://www.linkedin.com/company/ocaindonesia/mycompany/"
                >
                <svg class="self-center mx-2" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g clip-path="url(#clip0_537_269)">
                  <path d="M22.8225 20.9222C23.03 20.9242 23.2 20.7577 23.2021 20.5501C23.2022 20.5417 23.202 20.5332 23.2015 20.5247C23.2015 20.2428 23.0314 20.1082 22.6825 20.1082H22.1187V21.584H22.3307V20.9407H22.5913L22.5973 20.9485L23.0016 21.584H23.2284L22.7934 20.9263L22.8225 20.9222ZM22.5773 20.7744H22.3314V20.2755H22.643C22.804 20.2755 22.9875 20.3017 22.9875 20.5125C22.9875 20.755 22.8018 20.7744 22.576 20.7744H22.5773Z" fill="white"/>
                  <path d="M17.2911 19.0726H14.2842V14.3637C14.2842 13.2408 14.2642 11.7954 12.7203 11.7954C11.1542 11.7954 10.9147 13.0188 10.9147 14.282V19.0723H7.90781V9.38893H10.7944V10.7123H10.8348C11.4234 9.7059 12.5178 9.10482 13.6829 9.14804C16.7305 9.14804 17.2924 11.1526 17.2924 13.7604L17.2911 19.0726ZM4.515 8.06528C3.5513 8.06546 2.76994 7.28434 2.76975 6.32068C2.76956 5.35698 3.55069 4.57562 4.51434 4.57543C5.47805 4.57524 6.25941 5.35637 6.25959 6.32003C6.25978 7.28373 5.4787 8.06514 4.515 8.06528ZM6.01842 19.0727H3.00844V9.38893H6.01842V19.0727ZM18.7901 1.78314H1.49747C0.680203 1.7739 0.00998437 2.42856 0 3.24582V20.6102C0.00965625 21.4279 0.679781 22.0832 1.49747 22.0745H18.7901C19.6095 22.0847 20.2822 21.4295 20.2935 20.6102V3.2446C20.2819 2.4257 19.609 1.77109 18.7901 1.78187V1.78314Z" fill="white"/>
                  <path d="M22.6029 19.4507C21.8387 19.458 21.2251 20.0835 21.2325 20.8477C21.2398 21.6119 21.8653 22.2254 22.6295 22.2181C23.3938 22.2108 24.0073 21.5853 24 20.8211C23.9927 20.0673 23.3834 19.4579 22.6295 19.4507H22.6029V19.4507ZM22.6346 22.0591C21.9645 22.0703 21.3807 21.5368 21.3695 20.8667C21.3583 20.1967 21.8925 19.6445 22.5625 19.6333C23.2326 19.6222 23.7848 20.1563 23.7959 20.8263V20.8467C23.81 21.5021 23.29 22.0449 22.6346 22.0591Z" fill="white"/>
                  </g>
                  <defs>
                  <clipPath id="clip0_537_269">
                  <rect width="24" height="24" fill="white"/>
                  </clipPath>
                  </defs>
                </svg>

                </a>

                <a
                  class="self-center mx-2"
                  target="_blank"
                  href="https://www.facebook.com/OCA.IDN/"
                >
                <svg class="self-center mx-2" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M12 0.999878C14.0488 1.02326 15.8997 1.52679 17.5526 2.51046C19.1859 3.4745 20.5445 4.84143 21.4986 6.48053C22.4763 8.14345 22.9768 10.0055 23.0001 12.0668C22.942 14.8871 22.0525 17.2959 20.3314 19.2932C18.6104 21.2905 16.4062 22.5262 14.1244 22.9999V15.0927H16.2816L16.7695 11.9853H13.5029V9.95008C13.4848 9.52816 13.6182 9.11367 13.8791 8.78157C14.1403 8.44856 14.6003 8.27353 15.2592 8.25648H17.2317V5.53451C17.2034 5.52541 16.9349 5.4894 16.426 5.42649C15.849 5.35897 15.2687 5.3229 14.6877 5.31846C13.3728 5.32452 12.3328 5.69544 11.5679 6.43122C10.8029 7.16678 10.4121 8.23099 10.3956 9.62384V11.9853H7.9097V15.0927H10.3956V22.9999C7.59386 22.5262 5.38963 21.2905 3.6686 19.2932C1.94757 17.2959 1.05807 14.8871 1 12.0668C1.02323 10.0054 1.52372 8.14336 2.50146 6.48053C3.45554 4.84144 4.81417 3.47451 6.44743 2.51046C8.10034 1.52698 9.9512 1.02345 12 0.999878Z" fill="white"/>
                </svg>

                </a>
                <a
                  class="self-center mx-2"
                  target="_blank"
                  href="https://www.instagram.com/oca.indonesia/?hl=id"
                >
                <svg class="self-center mx-2" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M7.44428 1.07705C6.27388 1.13227 5.47461 1.31905 4.77589 1.59362C4.05275 1.87544 3.43983 2.25362 2.82998 2.86566C2.22014 3.4777 1.8446 4.09106 1.56476 4.81531C1.29394 5.51557 1.11046 6.31549 1.05876 7.48656C1.00706 8.65762 0.995618 9.03404 1.00134 12.0212C1.00706 15.0084 1.02026 15.3828 1.07702 16.5563C1.1329 17.7265 1.31902 18.5255 1.59358 19.2245C1.87584 19.9476 2.25358 20.5603 2.86584 21.1704C3.47811 21.7804 4.09103 22.1551 4.81703 22.4354C5.51663 22.7058 6.31678 22.8901 7.48762 22.9414C8.65847 22.9927 9.03533 23.0045 12.0216 22.9988C15.0079 22.9931 15.3839 22.9799 16.5572 22.9242C17.7304 22.8686 18.5253 22.6811 19.2244 22.4079C19.9476 22.125 20.5607 21.7479 21.1703 21.1354C21.78 20.5229 22.1553 19.9091 22.4349 19.1844C22.706 18.4848 22.8901 17.6847 22.9409 16.5147C22.9922 15.3406 23.0043 14.9657 22.9986 11.979C22.9928 8.99224 22.9794 8.6178 22.9238 7.44476C22.8681 6.27171 22.6818 5.47509 22.4074 4.77571C22.1247 4.05256 21.7474 3.4403 21.1354 2.8298C20.5233 2.2193 19.9091 1.8442 19.1846 1.56524C18.4846 1.29441 17.6849 1.10983 16.514 1.05923C15.3432 1.00863 14.9663 0.995653 11.9789 1.00137C8.99155 1.00709 8.61755 1.01985 7.44428 1.07705ZM7.57276 20.9625C6.50026 20.9158 5.91791 20.7376 5.52983 20.5885C5.01591 20.3905 4.64983 20.1511 4.26307 19.7681C3.87631 19.3851 3.63871 19.0177 3.43807 18.5049C3.28737 18.1168 3.10587 17.5351 3.05571 16.4626C3.00114 15.3034 2.9897 14.9554 2.98332 12.0186C2.97694 9.08178 2.98816 8.73418 3.03899 7.57456C3.08475 6.50293 3.26405 5.91993 3.41299 5.53207C3.61099 5.01749 3.84947 4.65207 4.23337 4.26552C4.61727 3.87898 4.98357 3.64094 5.49683 3.4403C5.88448 3.28894 6.46616 3.10898 7.53822 3.05794C8.69829 3.00294 9.04589 2.99194 11.9822 2.98556C14.9186 2.97918 15.2671 2.99018 16.4276 3.04122C17.4992 3.08786 18.0824 3.2654 18.4698 3.41522C18.984 3.61322 19.3498 3.85104 19.7364 4.23561C20.1229 4.62017 20.3612 4.98515 20.5618 5.49951C20.7134 5.88605 20.8934 6.46751 20.944 7.54024C20.9992 8.7003 21.0117 9.04812 21.017 11.9843C21.0223 14.9204 21.0119 15.2691 20.9611 16.4283C20.9143 17.5008 20.7365 18.0833 20.5871 18.4719C20.3891 18.9856 20.1504 19.3519 19.7663 19.7382C19.3822 20.1245 19.0163 20.3625 18.5028 20.5632C18.1156 20.7143 17.5333 20.8947 16.4621 20.9458C15.302 21.0003 14.9544 21.0118 12.017 21.0181C9.07955 21.0245 8.73305 21.0126 7.57298 20.9625M16.5402 6.12101C16.5406 6.3821 16.6185 6.6372 16.7639 6.85404C16.9094 7.07088 17.1158 7.23972 17.3572 7.33922C17.5986 7.43871 17.8641 7.46438 18.1201 7.41299C18.376 7.36159 18.611 7.23544 18.7953 7.05048C18.9796 6.86552 19.1049 6.63007 19.1553 6.3739C19.2058 6.11773 19.1791 5.85235 19.0788 5.61133C18.9784 5.3703 18.8088 5.16446 18.5914 5.01983C18.374 4.8752 18.1187 4.79829 17.8576 4.79881C17.5076 4.79951 17.1722 4.93919 16.9251 5.18714C16.6781 5.43509 16.5396 5.771 16.5402 6.12101ZM6.35198 12.0111C6.35814 15.1307 8.89167 17.6539 12.0106 17.648C15.1296 17.642 17.6545 15.1087 17.6486 11.9891C17.6426 8.86948 15.1084 6.34563 11.9891 6.35179C8.86967 6.35795 6.34604 8.89192 6.35198 12.0111ZM8.3333 12.0071C8.33187 11.2819 8.54552 10.5726 8.94723 9.96878C9.34895 9.36499 9.92068 8.89388 10.5901 8.61502C11.2596 8.33617 11.9967 8.2621 12.7083 8.40217C13.4198 8.54225 14.0739 8.89018 14.5877 9.40196C15.1015 9.91375 15.452 10.5664 15.5949 11.2774C15.7378 11.9884 15.6667 12.7258 15.3905 13.3964C15.1143 14.0669 14.6454 14.6405 14.0432 15.0446C13.441 15.4487 12.7325 15.6652 12.0073 15.6666C11.5258 15.6676 11.0488 15.5738 10.6035 15.3904C10.1582 15.207 9.75345 14.9377 9.41227 14.5979C9.0711 14.2581 8.80021 13.8544 8.61508 13.4099C8.42995 12.9653 8.3342 12.4887 8.3333 12.0071Z" fill="white"/>
                </svg>

                </a>

                <a
                  class="self-center mx-2"
                  target="_blank"
                  href="https://oca-telekomunikasi.medium.com/"
                >
                <svg class="self-center mx-2" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M13.5373 12C13.5373 15.7639 10.5069 18.8152 6.76866 18.8152C3.03042 18.8152 0 15.7639 0 12C0 8.23617 3.03042 5.18494 6.76866 5.18494C10.5068 5.18494 13.5373 8.23617 13.5373 12Z" fill="white"/>
                  <path d="M20.9627 12.0001C20.9627 15.5431 19.4475 18.4153 17.5784 18.4153C15.7093 18.4153 14.1941 15.5431 14.1941 12.0001C14.1941 8.45701 15.7093 5.58484 17.5784 5.58484C19.4476 5.58484 20.9627 8.45701 20.9627 12.0001Z" fill="white"/>
                  <path d="M23.9999 12.0001C23.9999 15.1745 23.467 17.7479 22.8096 17.7479C22.1522 17.7479 21.6194 15.1745 21.6194 12.0001C21.6194 8.82566 22.1522 6.25232 22.8096 6.25232C23.467 6.25232 23.9999 8.82566 23.9999 12.0001Z" fill="white"/>
                </svg>

                </a>

                <a
                  class="self-center mx-2"
                  target="_blank"
                  href="https://twitter.com/ask_oca?s=21/"
                >
                <svg class="self-center mx-2" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M13.6468 10.4686L20.9321 2H19.2057L12.8799 9.3532L7.82741 2H2L9.6403 13.1193L2 22H3.72649L10.4068 14.2348L15.7425 22H21.5699L13.6464 10.4686H13.6468ZM11.2821 13.2173L10.508 12.1101L4.34857 3.29967H7.00037L11.9711 10.4099L12.7452 11.5172L19.2066 20.7594H16.5548L11.2821 13.2177V13.2173Z" fill="white"/>
                </svg>

                </a>

                <a
                  class="self-center mx-2"
                  target="_blank"
                  href="https://www.youtube.com/channel/UCLNMdDMoe9RTdJw1_yjesfA/"
                >
                  <svg
                    class="self-center lg:mx-2"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M20.6338 7.98131C20.5314 7.60124 20.3312 7.25462 20.0532 6.97597C19.7751 6.69731 19.429 6.49633 19.0491 6.39303C17.6407 6.0063 12.0062 6.00001 12.0062 6.00001C12.0062 6.00001 6.37262 5.99371 4.96331 6.36335C4.58371 6.4714 4.23826 6.67523 3.96013 6.95525C3.682 7.23528 3.48052 7.5821 3.37504 7.96242C3.0036 9.37082 3 12.292 3 12.292C3 12.292 2.9964 15.2275 3.36514 16.6215C3.572 17.3922 4.17907 18.0011 4.95072 18.2089C6.37352 18.5956 11.9927 18.6019 11.9927 18.6019C11.9927 18.6019 17.6273 18.6082 19.0357 18.2394C19.4156 18.1363 19.7621 17.9358 20.0408 17.6577C20.3195 17.3796 20.5209 17.0336 20.6248 16.6539C20.9972 15.2464 20.9999 12.3261 20.9999 12.3261C20.9999 12.3261 21.0179 9.38971 20.6338 7.98131ZM10.2039 14.9981L10.2084 9.60196L14.8914 12.3045L10.2039 14.9981Z"
                      fill="white"
                    />
                  </svg>
                </a>

                <a
                  class="self-center mx-2"
                  target="_blank"
                  href="https://www.tiktok.com/@oca.indonesia"
                >
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M12.2131 3.015C13.1956 3 14.1705 3.0075 15.1455 3C15.2055 4.14749 15.618 5.31747 16.458 6.12746C17.298 6.95995 18.483 7.34245 19.638 7.46994V10.4924C18.558 10.4549 17.4705 10.2299 16.488 9.76492C16.0605 9.56992 15.663 9.32242 15.273 9.06742C15.2655 11.2574 15.2805 13.4474 15.258 15.6298C15.198 16.6798 14.853 17.7223 14.2455 18.5848C13.2631 20.0248 11.5606 20.9623 9.8131 20.9923C8.74062 21.0523 7.66813 20.7598 6.75314 20.2198C5.23816 19.3273 4.17317 17.6923 4.01568 15.9373C4.00068 15.5623 3.99318 15.1873 4.00818 14.8199C4.14317 13.3949 4.84817 12.0299 5.94315 11.0999C7.18814 10.0199 8.92811 9.50242 10.5556 9.80991C10.5706 10.9199 10.5256 12.0299 10.5256 13.1399C9.7831 12.8999 8.91312 12.9674 8.26062 13.4174C7.78813 13.7249 7.42813 14.1974 7.24064 14.7299C7.08314 15.1123 7.12814 15.5323 7.13564 15.9373C7.31563 17.1673 8.50062 18.2023 9.7606 18.0898C10.6006 18.0823 11.4031 17.5948 11.8381 16.8823C11.9806 16.6348 12.1381 16.3798 12.1456 16.0873C12.2206 14.7449 12.1906 13.4099 12.1981 12.0674C12.2056 9.04492 12.1906 6.02996 12.2131 3.015Z"
                      fill="white"
                    />
                  </svg>
                </a>
              </div>
            </div>
          </div>
          <div class="w-full py-10 pb-10">
            <div class="flex flex-1 space-between">
              <div class="flex flex-1 flex-row my-4">
                <div
                  @click="goto('termcondition')"
                  class="cursor-pointer text-white text-sm font-semibold mr-4"
                >
                  Privacy & Terms
                </div>
                <div
                  @click="goto('hubungi-kami')"
                  class="cursor-pointer text-white text-sm font-semibold mx-4"
                >
                  Contact Us
                </div>
              </div>
              <div
                @click="openModalLang()"
                class="multi-lang-content mr-4 desktop-hidden"
              >
                <span class="mx-1">{{ currLanguage }}</span>
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M4 6L8 10L12 6"
                    stroke="white"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
            </div>

            <div class="text-white text-sm my-4">© Copyright {{ currentYear }} OCA Indonesia, Inc. All rights reserved. Various trademarks held by their respective owners.</div>
          </div>
        </div>
      </div>
    </div>

    <!-- KOMPONEN MODAL -->
    <multilang-modal />
  </div>
</template>
<script>
// import OcaButton from './buttons';
import { APP_LAYOUT } from "../../app-settings/home";

import MultilangModal from "../../components/MultilangModal.vue";

export default {
    name: 'App',
    components: {
      MultilangModal
    },
    data: function () {
      return {
        listData: {},
        section_1: {},
        currLanguage: 'EN',
        currentYear: new Date().getFullYear(),
      }
    },
    mounted() {
        this.listData = APP_LAYOUT;
        if (localStorage.getItem('lang') === 'en') {
            this.section_1 = this.listData.header_eng
            this.currLanguage = 'EN';
        } else {
            this.section_1 = this.listData.header_id
            this.currLanguage = 'ID';
            localStorage.setItem('lang', 'id')
        }
    },
    methods:{
      openModalLang: function() {
        this.$modal.show("multilang-modal");
      },
       goto: function (url) {
          window.location.assign(`${window.location.protocol}//${window.location.host}/${url}`)
      },
      gotoTerms: function () {
          window.location.href = 'https://drive.google.com/file/d/1lHuOa4whOp9iFMVmaAf843tj2MYJtV2i/view'
      },
      gotoWa(){
        window.open('https://api.whatsapp.com/message/CJYNUR2AAUSVG1','_blank');
      }
  },
  computed: {
    hostPath(){
      return `${window.location.protocol}//${window.location.host}`
    },
    hostOrigin(){
      return `${window.location.protocol}//${window.location.host}`
    }
  }
}
</script>

<style>
@media (min-width: 320px) and (max-width: 600px) {
  .multi-lang-content {
    display: flex;
    flex-direction: row;
    cursor: pointer;
  }

  .multi-lang-content span {
    font-weight: 600;
    font-size: 14px;
    line-height: 15px;
    display: flex;
    align-items: center;
    color: #ffffff;
  }

  .multi-lang-content svg {
    align-self: center;
  }

  .mobile-view {
    display: flex;
  }

  .desktop-view {
    display: none;
  }
}

@media (min-width: 601px) and (max-width: 1024px) {
  .desktop-hidden {
    display: none !important;
  }

  .mobile-view {
    display: flex;
  }

  .desktop-view {
    display: none;
  }

  .hide-br {
    display: none !important;
  }
  .multi-lang-content {
    display: flex;
    flex-direction: row;
    cursor: pointer;
  }

  .multi-lang-content span {
    font-weight: 600;
    font-size: 14px;
    line-height: 15px;
    display: flex;
    align-items: center;
    color: #ffffff;
  }

  .multi-lang-content svg {
    align-self: center;
  }
}

@media (min-width: 1025px) {
  /* big landscape tablets, laptops, and desktops */
  .mobile-view {
    display: none !important;
  }

  .desktop-view {
    display: flex;
  }
}

@media (min-width: 1281px) {
  /* hi-res laptops and desktops */
  .mobile-view {
    display: none;
  }

  .desktop-view {
    display: flex;
  }
}

.multi-lang-content {
  display: flex;
  flex-direction: row;
  cursor: pointer;
}

  .multi-lang-content span {
    font-weight: 600;
    font-size: 14px;
    line-height: 15px;
    display: flex;
    align-items: center;
    color: #ffffff;
  }

  .multi-lang-content svg {
    align-self: center;
  }
</style>
